import { withAuth } from '../../auth/withAuth';
import Home from '../../home/Home';

export default withAuth(Home);
